module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Buchs_AG-2c4ccfcfa388d8144c287eae52604249.svg";